<template>
  <section class="section">
    <h2 class="section-title">公司新闻</h2>
    <div class="news-list">
      <div class="news-item" v-for="item in news" :key="item.year + item.title">
        <div class="news-year">{{ item.year }}</div>
        <div class="news-content">
          <div class="news-title">{{ item.title }}</div>
          <div class="news-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const news = [
  {
    year: '2025',
    title: '二手车拍卖平台开发',
    desc: '开发二手车拍卖平台系统，集成用户端、商户端与管理后台，助力车易懂在汽车流通领域的数字化转型。'
  },
  {
    year: '2025',
    title: '深度学习项目开发',
    desc: '结合人工智能，开发图片深度识别处理。'
  },
  {
    year: '2024',
    title: '非标设备上位机系统开发',
    desc: '与东莞道元合作，为重庆惠伦与湖南益阳信维开发多套非标自动化长线设备上位机系统，实现远程运维与集中管理。'
  },
  {
    year: '2024',
    title: '智能仓储PDA APP开发',
    desc: '智能料架PDA APP开发 涉及接口 系统对接 APP开发。'
  },
  {
    year: '2024',
    title: '智能锁平台开发',
    desc: '涉及后台，微信小程序 ，APP，前台开发。'
  },
  {
    year: '2023',
    title: '中盐ERP对接用友NCC项目简介',
    desc: '中盐的ERP需要对接到用友NCC系统，包含物料自动更新，采购单入库，销售单，成品出库单，产成品入库，材料出库单，材料退库单，退货单的对接，采用服务自动对接的方式。'
  },
  {
    year: '2023',
    title: '产线数据采集项目简介',
    desc: '产线数据采集项目简介： 本公司自研的面向工厂的产线数据采集系统，可以对接MES ，ERP，对产线的各种硬件设备进行对接，包含各种设备PLC ，物联设备，及产线的各种设备控制系统，上位机系统，下位机系统。'
  },
  {
    year: '2022',
    title: '脑电物联项目简介',
    desc: '有柔性脑贴，手环硬件，建设一个后台，并开发手机APP连接脑贴、手环，采集数据上报平台，平台有用户端和管理后台，同时开发微信小程序。'
  },
  {
    year: '2022',
    title: '深圳兰丁对接深圳卫健委项目简介',
    desc: '深圳兰丁的检测报告保存在自己的系统里，按深圳卫健委要求，需要对接到卫健委系统里，采用服务的方式自动传递检测单据到卫健委系统里去。'
  },
  {
    year: '2022',
    title: '与深圳鑫智峰合作',
    desc: '与深圳鑫智峰展开合作，开发PCB非标设备控制系统。'
  },
  {
    year: '2022',
    title: '脑电物联项目',
    desc: '建设脑电物联系统，包括柔性脑贴、手环硬件，后台平台、手机APP、小程序，支持数据采集与管理。'
  },
  {
    year: '2022',
    title: '公司成立',
    desc: '公司成立于中国创新之都——深圳，专注于软件开发、系统集成与技术服务，致力于提供高效、稳定、可持续的软件整体解决方案。'
  }
]
</script>

<style scoped>
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2em 1em;
  box-sizing: border-box;
  text-align: left;
}

.section-title {
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 1.5em;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
}

.news-item {
  display: flex;
  align-items: flex-start;
  background: #f8f8f8;
  padding: 1.2em;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.news-year {
  font-size: 1.2em;
  font-weight: bold;
  color: #007acc;
  width: 80px;
  flex-shrink: 0;
}

.news-content {
  flex: 1;
}

.news-title {
  font-size: 1.1em;
  font-weight: bold;
  margin-bottom: 0.3em;
  color: #333;
}

.news-desc {
  font-size: 0.96em;
  color: #555;
  line-height: 1.6;
}
</style>
